document.addEventListener('DOMContentLoaded', function () {
	const stockAlert = document.querySelector(
		'.product__stock-alert[data-schedule-time]'
	);
	if (!stockAlert) return;

	const scheduleTime = stockAlert.getAttribute('data-schedule-time');

	if (!scheduleTime || scheduleTime.trim() === '') {
		// No schedule time set, show immediately
		stockAlert.style.display = 'block';
	} else {
		// Parse the schedule time (supports YYYY-MM-DD HH:MM format)
		const scheduledDateTime = new Date(scheduleTime.replace(' ', 'T') + ':00Z'); // Add seconds and Z for UTC
		const currentDateTime = new Date();

		if (currentDateTime >= scheduledDateTime) {
			stockAlert.style.display = 'block';
		}
	}
});
